module.exports = __webpack_public_path__ + "static/media/Vela - Dk Chocolate_LT Grey.8dd67d8d.jpg";